import React, { useState } from 'react';

const Contact = () => {
  // Define state for the form status
  const [status, setStatus] = React.useState("");
  const [showSuccess, setShowSuccess] = React.useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("Sending...");
    // 1. Get values from the form
    const { name, email, message } = e.target.elements;
    let details = {
      name: name.value,
      email: email.value,
      message: message.value,
    };
    // 2. Send to our new Backend "Post Office"
    try {
      let response = await fetch("/api/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify(details),
      });
      let result = await response.json();
      // 3. Check result
      if (result.success) {
        setStatus("Sent!");
        setShowSuccess(true);
        e.target.reset(); // Clear the form
        setTimeout(() => setShowSuccess(false), 3000);
      } else {
        setStatus("Submit");
        alert("Failed to send: " + result.message);
      }
    } catch (error) {
      console.error(error);
      setStatus("Submit");
      alert("Error sending message. Please try again later.");
    }
  };

  return (
    <section id="contact">
      <div className="section-header">
        <h2 className="section-title">Get In Touch</h2>
        <p className="section-subtitle">Let's discuss how we can transform your business</p>
      </div>
      <div className="contact-container">
        <div className="contact-form-glass fade-in">
          <form className="contact-form" onSubmit={handleSubmit}>
            {showSuccess && (
              <div style={{
                background: 'var(--electric-blue, #2563EB)',
                color: '#fff',
                padding: '1rem',
                borderRadius: '8px',
                marginBottom: '1rem',
                textAlign: 'center',
                fontWeight: 600,
                boxShadow: '0 2px 12px rgba(37,99,235,0.15)'
              }}>
                Message sent successfully!
              </div>
            )}
            <div className="form-group">
              <label>Full Name</label>
              <input 
                type="text" 
                name="name"
                required 
                placeholder="Your Name"
              />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input 
                type="email" 
                name="email"
                required 
                placeholder="email@example.com"
              />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea 
                name="message"
                required
                placeholder="Tell us about your project..."
              ></textarea>
            </div>
            <button type="submit" className="glass-btn glass-btn-primary">
                <span>Send Message</span> →
            </button>
            {(status && status !== "Submit") && (
              <p style={{
                marginTop: '1rem', 
                color: status.includes('Failed') ? '#ff5f57' : '#4ade80',
                fontWeight: 'bold'
              }}>
                {status}
              </p>
            )}
          </form>
        </div>
        
        {/* Contact Info Side */}
        <div className="contact-info-glass fade-in">
            <div className="contact-item-glass">
                <div className="contact-icon-glass">📧</div>
                <div>
                    <h4>Email Us</h4>
                    <p>zentaksolutions@gmail.com</p>
                </div>
            </div>
            <div className="contact-item-glass">
                <div className="contact-icon-glass">📞</div>
                <div>
                    <h4>Call Us</h4>
                    <p>+94 70 128 5090</p>
                </div>
            </div>
            <div className="contact-item-glass">
                <div className="contact-icon-glass">📍</div>
                <div>
                    <h4>Visit Us</h4>
                    <p>Matara, Sri Lanka</p>
                </div>
            </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;